import { NgModule } from '@angular/core';
import { MagicCardDirective } from './magic-card.directive';

@NgModule({
    declarations: [
        MagicCardDirective
    ],
    imports: [],
    exports: [
        MagicCardDirective
    ]
})
export class NcMagicCardModule { }